import { render } from "./PaymentSuccessFaq.vue?vue&type=template&id=5cd49ae5"
import script from "./PaymentSuccessFaq.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__